module.exports = __webpack_public_path__ + "static/media/dayBackground@2x.5858e529.jpg";